"use client";

import {
  FlexBase,
  __objRest,
  __spreadValues
} from "./chunk-GS3VSUEK.mjs";

// src/Flex.tsx
import {
  mapResponsive,
  useBreakpointContext
} from "@teamsparta/stack-core";
import { forwardRef } from "react";
import { jsx } from "@emotion/react/jsx-runtime";
var _Flex = forwardRef(function FlexBase2(_a, ref) {
  var _b = _a, {
    as,
    direction = "row",
    align = "start",
    justify = "start",
    wrap = "nowrap",
    gap = 0,
    fullHeight = false,
    fullWidth = false,
    padding = 0
  } = _b, restProps = __objRest(_b, [
    "as",
    "direction",
    "align",
    "justify",
    "wrap",
    "gap",
    "fullHeight",
    "fullWidth",
    "padding"
  ]);
  const breakpoints = useBreakpointContext("Flex");
  const directions = mapResponsive(
    breakpoints,
    direction,
    (breakpoint, value) => ({
      breakpoint,
      value
    })
  );
  const aligns = mapResponsive(breakpoints, align, (breakpoint, value) => ({
    breakpoint,
    value
  }));
  const justifies = mapResponsive(
    breakpoints,
    justify,
    (breakpoint, value) => ({
      breakpoint,
      value
    })
  );
  const gaps = mapResponsive(breakpoints, gap, (breakpoint, value) => ({
    breakpoint,
    value
  }));
  const wraps = mapResponsive(breakpoints, wrap, (breakpoint, value) => ({
    breakpoint,
    value
  }));
  const fullWidths = mapResponsive(
    breakpoints,
    fullWidth,
    (breakpoint, value) => ({
      breakpoint,
      value
    })
  );
  const fullHeights = mapResponsive(
    breakpoints,
    fullHeight,
    (breakpoint, value) => ({
      breakpoint,
      value
    })
  );
  const paddings = mapResponsive(breakpoints, padding, (breakpoint, value) => ({
    breakpoint,
    value
  }));
  return /* @__PURE__ */ jsx(
    FlexBase,
    __spreadValues({
      ref,
      as,
      $direction: directions,
      $align: aligns,
      $justify: justifies,
      $gap: gaps,
      $wrap: wraps,
      $fullHeight: fullHeights,
      $fullWidth: fullWidths,
      $padding: paddings
    }, restProps)
  );
});
var Column = forwardRef(function ColumnBase(_a, ref) {
  var _b = _a, {
    direction = "column",
    align = "start",
    justify = "start",
    gap = 0,
    wrap = "nowrap"
  } = _b, restProps = __objRest(_b, [
    "direction",
    "align",
    "justify",
    "gap",
    "wrap"
  ]);
  return /* @__PURE__ */ jsx(
    Flex,
    __spreadValues({
      ref,
      direction,
      align,
      justify,
      gap,
      wrap
    }, restProps)
  );
});
var Row = forwardRef(function ColumnBase2(_a, ref) {
  var _b = _a, {
    direction = "row",
    align = "start",
    justify = "start",
    gap = 0,
    wrap = "nowrap"
  } = _b, restProps = __objRest(_b, [
    "direction",
    "align",
    "justify",
    "gap",
    "wrap"
  ]);
  return /* @__PURE__ */ jsx(
    Flex,
    __spreadValues({
      ref,
      direction,
      align,
      justify,
      gap,
      wrap
    }, restProps)
  );
});
var Flex = Object.assign(_Flex, {
  Column,
  Row
});

export {
  Flex
};
